var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-info",attrs:{"title":"Ausgenommene Urlaubstage diesen Monat / verfügbare Urlaubstage"}},[_vm._v(" "+_vm._s(_vm.leavesTaken)+"/"+_vm._s(_vm.formattedTotalPossibleLeaves)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }